<template>
  <div class="flex flex-col min-h-screen">
    <Header />
    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div
      class="flex-1 container mx-auto max-w-[1200px] w-full py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <!-- <SyallbusView/> -->
      <div class="w-full h-full flex flex-col gap-5">
        <div
          class="flex flex-col md:flex-row md:items-center md:justify-between gap-2"
        >
          <div>
            <h1 class="text-m font-semibold">
              User Instructions
              <span class="text-[16px]"> ({{ count_list || 0 }})</span>
            </h1>
          </div>
          <div class="flex flex-wrap md:items-center gap-3 md:justify-between">
            <div class="flex justify-end">
              <div class="relative w-full md:max-w-80">
                <div
                  class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                <input
                  type="text"
                  v-model="search_list"
                  @input="getSyllabus(1)"
                  placeholder="Search..."
                  class="w-full rounded-xl border border-gray-200 bg-white pl-10 pr-10 py-1.5 text-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
                <button
                  v-if="search_list"
                  @click="clearSearch"
                  class="absolute inset-y-0 right-0 pr-3 flex items-center"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-gray-400 hover:text-gray-600"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div>
              <button
                @click="this.addsyllabus = true"
                class="bg-blues hover:bg-hover text-white font-semibold text-xs px-4 py-1.5 rounded-xl transition-colors duration-200"
              >
                Add
              </button>
            </div>
            <router-link
              :to="{ name: 'InstructorHome' }"
              class="bg-blues hover:bg-hover text-white font-semibold text-xs px-4 py-1.5 rounded-xl transition-colors duration-200"
            >
              Back
            </router-link>
          </div>
        </div>
        <div>
          <div
            class="w-full flex flex-col gap-5 pb-20"
            v-if="syllabus_list.length > 0"
          >
            <div
              class="w-full bg-white rounded-2xl shadow-sm border border-slate-200 overflow-x-auto"
            >
              <table class="min-w-full">
                <thead>
                  <tr
                    class="text-left bg-gray-100 text-textblues whitespace-nowrap text-sm capitalize"
                  >
                    <th class="px-4 py-3 border-b border-r">S.No</th>
                    <th class="px-4 py-3 border-b border-r">Title</th>
                    <th class="px-4 py-3 border-b border-r">Year</th>
                    <th class="px-4 py-3 border-b border-r">PDF</th>
                    <th class="px-4 py-3 border-b border-r">Comments</th>
                    <th class="px-4 py-3 border-b border-r">Edit</th>
                    <th class="px-4 py-3 border-b border-r">Delete</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(list, index) in syllabus_list"
                    :key="index"
                    class="border-b pb-3 w-full cursor-pointer hover:bg-gray-50 text-sm"
                  >
                    <td class="px-4 py-3 border-b border-r text-gray-500">
                      {{ (currentPage - 1) * pageSize + index + 1 }}
                    </td>
                    <td class="px-4 py-3 border-b border-r text-gray-800">
                      {{ list.title }}
                    </td>
                    <td class="px-4 py-3 border-b border-r">
                      {{ list.years }}
                    </td>
                    <td class="px-4 py-3 border-b border-r text-gray-500">
                      <a :href="list.pdf" target="_blank" class="text-textblues">{{
                        list.pdf?.split("/")?.pop() || "-"
                      }}</a>
                    </td>
                    <td class="px-4 py-3 border-b border-r text-gray-500">
                      {{ list.command }}
                    </td>
                    <td class="px-4 py-3 border-b border-r text-gray-500">
                      <button @click="openEditPopup(list.id)" class="">
                        <img
                          src="@/assets/new/medit.png"
                          alt=""
                          srcset=""
                          class="w-6 h-6 bg-[#EDF8FF] p-1"
                        />
                      </button>
                    </td>
                    <td class="px-4 py-3 border-b border-r text-gray-500">
                      <button
                        @click="
                          titlepass = list.title;
                          popupwindow = true;
                          idpass = list.id;
                        "
                        class=""
                      >
                        <img
                          src="@/assets/new/dele.png"
                          alt=""
                          srcset=""
                          class="w-6 h-6 bg-[#FF29291A] p-1"
                        />
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              v-if="count_list >= 11"
              class="flex flex-col sm:flex-row justify-center gap-3 mt-4 relative"
            >
              <!-- PAGE SIZE -->
              <div
                class="md:absolute md:left-3 md:top-4 gap-2 text-sm text-gray-600 flex justify-center items-center md:flex-none md:justify-normal"
              >
                <span class="flex md:hidden">Rows per page:</span>
                <select
                  v-model="pageSize"
                  @change="onPageSizeChange"
                  class="border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>

              <!-- PAGINATION -->
              <div class="flex justify-center">
                <Pagination
                  :totalPages="totalPages"
                  ref="paginationRef"
                  @page-changed="getSyllabus"
                />
              </div>
            </div>
          </div>
          <div v-else>
            <div
              class="flex flex-col items-center justify-center gap-4 py-16 px-4"
            >
              <div class="bg-gray-50 rounded-full p-6">
                <svg
                  class="w-16 h-16 text-gray-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                  />
                </svg>
              </div>
              <div class="text-center">
                <h3 class="text-gray-600 text-lg font-semibold mb-1">
                  No instruction available
                </h3>
                <p class="text-gray-400 text-sm">
                  Get started by creating a new instruction
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Add popup -->
        <div
          v-if="this.addsyllabus"
          @click.self="this.addsyllabus = false"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="lg:w-[30%] bg-white rounded-xl p-5 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-center">
              <h3 class="text-xl font-bold text-textblues text-center">
                Add Instruction
              </h3>
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="createTeamRef"
                  @submit.prevent="createSyllabus"
                  class="flex flex-col gap-2 text-xs md:text-sm lg:text-base h-full"
                >
                  <div class="w-full flex flex-col gap-2">
                    <label
                      for="syllabus_title"
                      class="flex items-center text-left text-sm font-medium text-gray-700 gap-1"
                    >
                      <span>Title</span>
                      <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                          Provide a descriptive title
                        </div>
                      </div>
                    </label>

                    <div class="relative">
                      <input
                        required
                        id="syllabus_title"
                        type="text"
                        placeholder="Title"
                        maxlength="150"
                        oninput="
        const len = this.value.length;
        const counter = document.getElementById('char_counter');
        const warning = document.getElementById('char_warning');

        counter.textContent = len + '/150';

        if (len >= 150) {
          counter.className = 'absolute right-2 top-1/2 -translate-y-1/2 text-xs font-medium text-red-500';
          warning.textContent = 'Character limit reached!';
          warning.className = 'text-xs text-red-500';
        } else if (len >= 120) {
          counter.className = 'absolute right-2 top-1/2 -translate-y-1/2 text-xs font-medium text-yellow-500';
          warning.textContent = 'Only ' + (150 - len) + ' characters remaining.';
          warning.className = 'text-xs text-yellow-500';
        } else {
          counter.className = 'absolute right-2 top-1/2 -translate-y-1/2 text-xs font-medium text-gray-400';
          warning.textContent = '';
        }
      "
                        class="w-full border border-gray-200 rounded text-xs md:text-sm lg:text-base py-2 pl-2 pr-16"
                      />
                      <span
                        id="char_counter"
                        class="absolute right-2 top-1/2 -translate-y-1/2 text-xs font-medium text-gray-400"
                      >
                        0/150
                      </span>
                    </div>

                    <p id="char_warning" class="text-xs"></p>
                  </div>

                  <div class="w-full flex flex-col gap-2">
                    <label
                      for="syllabus_date"
                      class="flex items-center text-left text-sm font-medium text-gray-700 gap-1"
                    >
                      <span>Year <span class="text-red-400">*</span></span>
                      <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                          Provide a descriptive year YYYY
                        </div>
                      </div>
                    </label>
                    <input
                      required
                      id="syllabus_date"
                      type="text"
                      placeholder="YYYY"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>

                  <div class="flex flex-col gap-3 w-full">
                    <label for="syllabus_pdf" class="text-left"
                      >PDF <span class="text-red-400">*</span></label
                    >
                    <input
                      id="syllabus_pdf"
                      type="file"
                      multiple
                      accept=".pdf"
                      class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                      required
                    />
                  </div>
                  <div class="flex flex-col gap-3 w-full">
                    <label for="syllabus_command" class="text-sm"
                      >Comments</label
                    >
                    <textarea
                      id="syllabus_command"
                      required
                      maxlength="1000"
                      class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                    ></textarea>
                  </div>

                  <div class="flex justify-center pb-4 mt-3 gap-10">
                    <button
                      @click="this.addsyllabus = false"
                      class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                    >
                      Close
                    </button>
                    <div class="flex justify-end items-center gap-3">
                      <button
                        type="submit"
                        :disabled="disable_submit == true"
                        :class="
                          this.disable_submit == true
                            ? 'bg-gray-200 text-black cursor-not-allowed'
                            : 'bg-blues hover:bg-hover cursor-pointer text-white'
                        "
                        class="rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                      >
                        Add
                      </button>
                      <img
                        v-if="disable_submit"
                        src="@/assets/loading.gif"
                        alt="loading"
                        class="w-6 h-6 object-contain"
                      />
                    </div>

                    <!-- <button
                      type="submit"
                      class="text-white bg-blues rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                    >
                      Submit
                    </button> -->
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <!-- Edit popup -->
        <div
          v-if="this.isEditing"
          class="fixed bg-primary bg-opacity-30 top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center"
        >
          <div
            class="lg:w-[30%] bg-white rounded-xl p-5 overflow-y-auto max-h-[600px]"
          >
            <div class="flex items-center justify-center">
              <h3 class="text-xl font-bold text-textblues text-center">
                Edit Instruction
              </h3>
            </div>

            <div
              class="w-full mt-4 flex flex-col p-6 relative border-gray-100 rounded-2xl"
            >
              <div class="w-full">
                <form
                  ref="createTeamRef"
                  @submit.prevent="editSyllabus"
                  class="flex flex-col gap-2 text-xs md:text-sm lg:text-base h-full"
                >
                  <div class="w-full flex flex-col gap-2">
                    <label
                      for="syllabus_title"
                      class="flex items-center text-left text-sm font-medium text-gray-700 gap-1"
                    >
                      <span>Title</span>
                      <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                          Provide a descriptive title
                        </div>
                      </div>
                    </label>

                    <input
                      id="syllabus_title"
                      v-model="editsyllabus_list.title"
                      type="text"
                      class="border border-gray-200 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>

                  <div class="w-full flex flex-col gap-2">
                    <label
                      for="syllabus_date"
                      class="flex items-center text-left text-sm font-medium text-gray-700 gap-1"
                    >
                      <span>Year <span class="text-red-400">*</span></span>
                      <div class="relative group">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-4 w-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm-.75-6a.75.75 0 011.5 0v1.25a.75.75 0 01-1.5 0V12zm0-6a.75.75 0 011.5 0v3a.75.75 0 01-1.5 0V6z"
                            clip-rule="evenodd"
                          />
                        </svg>
                        <div
                          class="absolute z-10 hidden group-hover:block w-48 rounded bg-gray-800 p-2 text-xs text-white top-5 left-16 -translate-x-1/2"
                        >
                          Provide a descriptive year YYYY
                        </div>
                      </div>
                    </label>
                    <input
                      id="syllabus_date"
                      type="text"
                      v-model="editsyllabus_list.years"
                      class="border border-gray-100 rounded text-xs md:text-sm lg:text-base py-2 px-2"
                    />
                  </div>

                  <div class="flex flex-col gap-3 w-full">
                    <label for="syllabus_pdf" class="text-left"
                      >Pdf <span class="text-red-400">*</span></label
                    >

                    <input
                      id="syllabus_pdf"
                      type="file"
                      accept=".pdf"
                      class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                      @change="handleFileUpload"
                    />
                    <a
                      v-if="editsyllabus_list.pdf"
                      :href="editsyllabus_list.pdf"
                      target="blank"
                      class="text-sm text-textblues"
                      >{{ editsyllabus_list.pdf.split("/").pop() }}</a
                    >
                  </div>
                  <div class="flex flex-col gap-3 w-full">
                    <label for="syllabus_command" class="text-sm"
                      >Comments</label
                    >
                    <textarea
                      id="syllabus_command"
                      maxlength="1000"
                      v-model="editsyllabus_list.command"
                      class="bg-gray-100 py-2 px-2 w-full rounded text-xs md:text-sm lg:text-base"
                    ></textarea>
                  </div>

                  <div class="flex justify-center pb-4 mt-3 gap-10">
                    <button
                      @click="this.isEditing = false"
                      class="border text-gray-500 rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                    >
                      Close
                    </button>

                    <div class="flex justify-end items-center gap-3">
                      <button
                        type="submit"
                        :disabled="disable_submit == true"
                        :class="
                          this.disable_submit == true
                            ? 'bg-gray-200 text-black cursor-not-allowed'
                            : 'bg-blues hover:bg-hover cursor-pointer text-white'
                        "
                        class="rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                      >
                        Update
                      </button>
                      <img
                        v-if="disable_submit"
                        src="@/assets/loading.gif"
                        alt="loading"
                        class="w-6 h-6 object-contain"
                      />
                    </div>
                    <!-- <button
                      type="submit"
                      class="text-white bg-blues rounded-lg text-sm px-5 lg:px-10 font-semibold py-2"
                    >
                      Submit
                    </button> -->
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <!-- delect popup -->

        <div
          v-if="popupwindow"
          class="fixed flex bg-black bg-opacity-70 justify-center items-center inset-0 z-50 outline-none overflow-x-hidden overflow-y-auto"
          style="z-index: 5000"
        >
          <div class="w-[90%] lg:w-[35%] rounded-md m-4">
            <div
              class="relative flex flex-col clear-both justify-center rounded-t-lg w-full pt-12 p-4 md:p-10 bg-white gap-3"
            >
              <img
                @click="popupwindow = false"
                class="absolute right-2 top-2 cursor-pointer"
                src="@/assets/newd/close.png"
              />
              <p class="text-center font-base text-xl text-gray-600">
                Are you sure want to delete ?
              </p>
              <h1 class="text-center font-bold text-xl text-textblues">
                {{ titlepass }}
              </h1>
            </div>
            <div
              class="body-popup flex flex-col rounded-b-lg py-3 md:py-6 px-3 md:px-6 bg-gray-200"
            >
              <div class="flex gap-4 justify-between w-full md:w-3/4 mx-auto">
                <!-- <button
                  @click="deleteSyllabus"
                  class="bg-teal-800 hover:bg-teal-600 text-white text-sm font-semibold rounded overflow-hidden px-4 py-2"
                >
                  Yes
                </button> -->

                <button
                  @click="popupwindow = false"
                  class="bg-white hover:bg-gray-300 text-gray-700 text-sm font-semibold rounded overflow-hidden px-4 py-1"
                >
                  Cancel
                </button>
                <div class="flex justify-end items-center gap-3">
                  <button
                    type="submit"
                    @click="deleteSyllabus"
                    :disabled="disable_submit == true"
                    :class="
                      this.disable_submit == true
                        ? 'bg-white text-black cursor-not-allowed'
                        : 'bg-blues hover:bg-hover cursor-pointer text-white'
                    "
                    class="rounded-lg border outline-none text-sm px-4 font-semibold py-1"
                  >
                    Yes
                  </button>
                  <img
                    v-if="disable_submit"
                    src="@/assets/loading.gif"
                    alt="loading"
                    class="w-6 h-6 object-contain"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Admin/Header.vue";
// import SyallbusView from "@/components/SyallbusView.vue";
import Pagination from "@/components/Pagination.vue";
import FlashMessage from "@/components/FlashMessage.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import Footer from "@/components/Footer.vue";

export default {
  data() {
    return {
      addsyllabus: false,
      isEditing: false,
      popupwindow: false,
      messages: {
        text: "",
        type: "null",
      },
      // loading: true,
      syllabus_list: [],
      editsyllabusId: null,
      editsyllabus_list: [],
      currentPage: 1,
      totalPages: 1,
      pageSize: 10,
      titlepass: null,
      idpass: null,
      search_list: "",
      count_list: "",
      disable_submit: false,
    };
  },
  components: {
    Header,
    // SyallbusView,
    FlashMessage,
    Pagination,
    Footer,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {
    this.getSyllabus(1);
  },
  methods: {
    clearSearch() {
      this.search_list = "";
      this.getSyllabus(1);
    },
    async getSyllabus(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/syllabus-overall-list/?page=${page}&search=${this.search_list}&page_size=${this.pageSize}&Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.totalPages = response.data.total_page;
            this.syllabus_list = response.data.data.data;
            this.count_list = response.data.total;
            this.currentPage = response.data.current_page;
          } else {
            console.log("got error");
          }
        });
    },

    onPageSizeChange() {
      this.currentPage = 1;
      if (this.$refs.paginationRef) {
        this.$refs.paginationRef.currentPage = 1;
      }
      this.getSyllabus(1);
    },

    // async getSyllabus(page) {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/syllabus-overall-list/?page=${page}&page_size=${this.pageSize}&search=${this.search_list}&Key=${this.userInfo.token_key}`,
    //     )
    //     .then((response) => {
    //       if (response.data.data.status == 200) {
    //         this.totalPages = response.data.total_page;
    //         this.syllabus_list = response.data.data.data;
    //         this.count_list = response.data.total;
    //       }
    //     });
    // },

    async createSyllabus(event) {
      this.disable_submit = true;
      const el = event.target;

      let token = this.userInfo.token_key;

      let urls = `${process.env.VUE_APP_API}/syllabus-create/?Key=${token}`;
      let formData = new FormData();

      formData.append("title", el.elements.syllabus_title.value);

      formData.append("years", el.elements.syllabus_date.value);

      formData.append("command", el.elements.syllabus_command.value);
      formData.append("user", this.userInfo.user.id);
      const fileInput = el.elements.syllabus_pdf;
      if (fileInput && fileInput.files.length > 0) {
        for (let i = 0; i < fileInput.files.length; i++) {
          formData.append("pdf", fileInput.files[i]);
          await axios
            .post(urls, formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((response) => {
              if (response.data.status == 200) {
                this.messages = {
                  text: response.data.message,
                  type: "success",
                };
                setTimeout(() => {
                  this.messages = {
                    text: "",
                    type: "null",
                  };
                  this.disable_submit = false;
                  this.addsyllabus = false;
                }, 1500);
              } else {
                this.messages = {
                  text: " Event Faild",
                  type: "error",
                };
                setTimeout(() => {
                  this.messages = {
                    text: "",
                    type: "null",
                  };
                  this.disable_submit = false;
                }, 2000);
              }
            })
            .finally(() => {});
        }
        setTimeout(() => {
          this.disable_submit = false;
          el.reset();
          this.getSyllabus(1);
        }, 2000);
      }
    },

    openEditPopup(id) {
      this.editsyllabusId = id;
      axios
        .get(
          `${process.env.VUE_APP_API}/syllabus-overall-list/?Key=${this.userInfo.token_key}&id=${id}`,
        )
        .then((response) => {
          if (response.data.data.status == 200) {
            this.editsyllabus_list = response.data.data.data[0];
          } else {
            console.log("got error");
          }
        });

      this.isEditing = true;
    },
    handleFileUpload(event) {
      this.thumbnailFile = event.target.files[0];
    },
    async editSyllabus(e) {
      this.disable_submit = true;
      let updatedEditInfo = new FormData();
      updatedEditInfo.append("title", e.target.elements.syllabus_title.value);
      updatedEditInfo.append("years", e.target.elements.syllabus_date.value);
      updatedEditInfo.append(
        "command",
        e.target.elements.syllabus_command.value,
      );

      if (this.thumbnailFile) {
        updatedEditInfo.append("pdf", this.thumbnailFile);
      }

      await axios
        .put(
          `${process.env.VUE_APP_API}/syllabus-retrieve-update/${this.editsyllabusId}/?Key=${this.userInfo.token_key}`,
          updatedEditInfo,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        })
        .finally(() => {
          // this.disable_submit = false;
        });

      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.isEditing = false;
        this.disable_submit = false;
        this.getSyllabus(this.currentPage);
      }, 2500);
    },
    async deleteSyllabus() {
      this.disable_submit = true;
      await axios
        .delete(
          `${process.env.VUE_APP_API}/syllabus-retrieve-update/${this.idpass}/?Key=${this.userInfo.token_key}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
          }
        });
      setTimeout(() => {
        this.messages = {
          text: "",
          type: "null",
        };
        this.popupwindow = false;
        this.disable_submit = false;
        this.getSyllabus(1);
      }, 2500);
    },
  },
};
</script>

<style></style>
